import { render, staticRenderFns } from "./8BitatBat.vue?vue&type=template&id=74789fed&scoped=true"
import script from "./8BitatBat.vue?vue&type=script&lang=js"
export * from "./8BitatBat.vue?vue&type=script&lang=js"
import style0 from "./8BitatBat.vue?vue&type=style&index=0&id=74789fed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74789fed",
  null
  
)

export default component.exports